import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ReactLenis } from "lenis/react";
import { QuoteProvider } from "@/context/QuoteContext";
import { Toaster } from "@/components/ui/sonner";
import Home from "@/pages/Home";
import RequestReceived from "@/pages/RequestReceived";

function App() {
  return (
    <BrowserRouter>
      <ReactLenis root options={{ lerp: 0.09, smoothWheel: true }}>
        <QuoteProvider>
          <div className="App grain" data-testid="app-root">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/request-received" element={<RequestReceived />} />
            </Routes>
            <Toaster position="top-center" richColors />
          </div>
        </QuoteProvider>
      </ReactLenis>
    </BrowserRouter>
  );
}

export default App;
